// ================ Action types ================ //

import { restApiService } from '../../services/services';
import { handleAxiosResponse } from '../../util/apiHelpers';
import { axiosStorableError } from '../../util/errors';

const IS_OPEN_SET = 'app/InviteBrokerModal/IS_OPEN_SET';
const SEND_INVITE_REQUEST = 'app/InviteBrokerModal/SEND_INVITE_REQUEST';
const SEND_INVITE_SUCCESS = 'app/InviteBrokerModal/SEND_INVITE_SUCCESS';
const SEND_INVITE_ERROR = 'app/InviteBrokerModal/SEND_INVITE_ERROR';

const initialState = {
  isOpen: false,
  isInviteSuccess: false,
  inviteInProgress: false,
  inviteError: null,
};

export default function inviteBrokerModalReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case IS_OPEN_SET:
      return {
        ...(payload === true ? {
          ...state,
          isOpen: payload,
        } : initialState),
      };

    case SEND_INVITE_REQUEST:
      return {
        ...state,
        isInviteSuccess: false,
        inviteInProgress: true,
        inviteError: null,
      };

    case SEND_INVITE_SUCCESS:
      return {
        ...state,
        isInviteSuccess: true,
        inviteInProgress: false,
      };

    case SEND_INVITE_ERROR:
      return {
        ...state,
        isInviteSuccess: false,
        inviteInProgress: false,
        inviteError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const isOpenSet = value => ({
  type: IS_OPEN_SET,
  payload: value,
});

const sendInviteRequest = () => ({
  type: SEND_INVITE_REQUEST,
});

const sendInviteSuccess = () => ({
  type: SEND_INVITE_SUCCESS,
});

const sendInviteError = error => ({
  type: SEND_INVITE_ERROR,
  payload: error,
});

// ================ Selectors ================ //

const $subState = state => {
  return state.InviteBrokerModal;
};

export const $modalState = state => {
  const subState = $subState(state);
  return {
    isOpen: subState.isOpen,
  };
};

export const $inviteState = state => {
  const subState = $subState(state);
  return {
    inProgress: subState.inviteInProgress,
    error: subState.inviteError,
    isInviteSuccess: subState.isInviteSuccess,
  };
};

// ================ Thunks ================ //

export const openModal = () => dispatch => {
  dispatch(isOpenSet(true));
};

export const closeModal = () => dispatch => {
  dispatch(isOpenSet(false));
};

export const sendInvite = values => dispatch => {
  dispatch(sendInviteRequest());
  return restApiService.secureInstance
    .postRaw('brokers/invite-broker', {
      brokerEmail: values.email,
    })
    .then(handleAxiosResponse)
    .then(resp => {
      dispatch(sendInviteSuccess());
      return resp;
    })
    .catch(e => {
      dispatch(sendInviteError(axiosStorableError(e).message));
      throw e;
    })
  ;
};
